import {initializeCaptcha, handleCaptchaSubmit} from './Components/ReCaptcha/Captcha';
import {initializePasswordRequirements, handlePasswordLength, handlePasswordRequirementsSubmit} from './Components/Form/PasswordRequirements';
import {handleRequiredCheckboxChange, handleRequiredCheckboxSubmit} from './Components/Form/RequiredCheckbox';
import {state as selectState} from './Components/Form/SearchableSelects/State';
import {CloseDropdowns} from './Components/Form/SearchableSelects/Event';
import {clickSelectContainer} from './Components/Form/SearchableSelects/Handler';
import {state as dropdownState} from './Components/DropdownMenu/State';
import {CloseDropdownMenus} from './Components/DropdownMenu/Event';
import {clickDropdownContainer, closeRequestingDropdown} from './Components/DropdownMenu/Handler';
import {clearRelativeTimeIntervals, renderRelativeTimesIn, timeElementClickedHandler} from "./Library/Time";
import {copySwappedContent, copyText} from "./Library/Clipboard.js";
import {celebrate} from "./Library/Confetti.js";
import {removeTransientOverlays} from './Library/HtmxHistory';
import {dropRepeatedRequest, prepareButtonSpinner} from './Components/Form/ButtonSpinner';
import {releaseFrozenRequestState} from './Library/HtmxRequestState';
import {removeAllTags} from './Components/Form/EditableStoreTagSelector';
import {FocusInput, RemoveEditableTag, RemoveLastTag, TagInputContent} from './Components/Form/EditableTags';
import {handleFilterCardToggle, handleFilterCardModeChange} from './Components/Form/FilterField';
import {handleFolderScopeModeChange} from './Components/Form/FolderScope';
import {handleIntervalToggleChange, handleSettingToggleChange, syncTogglesOnRestore} from './Components/Form/IntervalToggle';
import {GroupedCheckboxChanged} from './Components/Permissions/Event';
import {isLockedPermission, syncPermissionDependencies} from './Components/Permissions/Dependencies';
import {
    appendContextIdsToRequest,
    checkAllOnDropdownOpen,
    handleCheckboxGroupClick,
    initializeCheckboxGroups,
    refreshContextElements,
    toggleAllInScope,
    updateContextElements,
} from './Components/Form/CheckboxGroup';
import {addAddressLine} from './Components/Form/AddressLines';
import {revealOptionalField} from './Components/Form/OptionalFields';
import {
    advanceMfaInput,
    clearMfaInput,
    distributeFilledMfaCode,
    distributePastedMfaCode,
    initializeMfaInputs,
} from './Components/Form/MfaInputGroup';
import {addRow as addFieldsetRow, removeRow as removeFieldsetRow, prepareSubmission as prepareFieldsetSubmission} from './Components/Form/RepeatableFieldset';
import {initializeDirtyForms, initializeShakeWhenDirty, markAssociatedFormDirty, shakeDirtyFormsOutside} from './Components/Form/DirtyForm';
import {
    handleSidebarClick,
    handleSidebarMouseOut,
    handleSidebarMouseOver,
    handleSidebarTransitionEnd,
    resetSidebar,
    syncFoldersCollapseHandle,
} from './Components/Sidebar';
import {clearField, focusNewRow, removeRow} from './Components/Form/FieldRows';
import {
    handleSuggestionsFocus,
    handleSuggestionsInput,
    handleSuggestionsKeydown,
    handleSuggestionsMousedown,
} from './Components/Form/InputSuggestions';
import {syncBodyClass} from './Components/BodyClass';
import {confirmFormSubmission, hideConfirmedModal} from './Components/ConfirmModal';
import {handleInlineConfirm} from './Components/InlineConfirm';
import {returnToTemplateSelector} from './Components/SendEmailModal';
import {collapse} from './Components/Collapsible';
import {openFormModal} from './Components/FormModal';
import {handleBulkActionChange} from './Components/Order/BulkActions';
import {handleProductPrefill} from './Components/Order/AddItemPrefill';
import {handleSteppedIntegerStep} from './Components/Form/SteppedInteger';
import {applyDefaultPort} from './Components/Form/DefaultPort';
import {initializeScrollToError} from './Components/Form/ScrollToError';
import {handleConnectionTestInput, syncConnectionTestButtons, trustTestedIdentity} from './Components/Form/ConnectionTest';
import {
    clearSubmissionValidationState,
    handleSubmissionValidationHalted,
} from './Components/Order/SubmissionPreview';
import {handleCreatePdfSubmit} from './Components/Order/CreatePdf';
import {handleLabelPurchaseChange, syncLabelBuyButton} from './Components/Order/LabelPurchase';
import {clearPreviewHighlight, navigatePreview, syncPreviewNav, triggerRowPreview} from './Components/RowPreview';
import {toggleRows} from './Components/ExpandableRows';
import {switchTab} from './Components/ContentTabs';
import {confirmHtmxAction} from './Components/HtmxConfirm';
import {openPanel} from './Components/SidePanel';
import {changePerPage, closeJumpInput, openJumpInput, submitJump} from './Components/Pagination';
import {closeContextDialog, positionContextDialog} from './Components/ContextDialog';
import {fromString as showToast, initializeToastMessages} from './Components/ToastMessage';
import {showRequestErrorToast, showResponseErrorToast, showBoostedErrorPage} from './Components/RequestError';
import {popTagColorSwatch, refreshTagPreview} from './Components/TagPreview';
import {flyBundleItem, rememberBundleItemFlight} from './Components/BundleItemFly';
import {addInventoryRow, removeInventoryRow} from './Components/InventoryEdit';
import {focusFilterInput, removeFilterRow} from './Components/SearchFilters';
import {openSelectOnFocus} from './Components/Form/Select/Focus';
import tippy from 'tippy.js';
import {initializeDatepicker, toggleDatepickerFromSuffix} from './Components/Form/DatePicker';
import {initializeScheduleFields} from './Components/Form/ScheduleField';
import {handleAllNotificationsRead, handleNotificationBellClick, handleNotificationRead} from './Components/UserNotifications';
import {enableScreenshotMode} from './Components/UserMenu';
import {initializeImagePreview} from './Components/ImagePreview';
import {initializeCellPreviews} from './Components/CellPreview';
import {initializePlanEstimator} from './Components/PlanEstimator';
import {initializeLineNumberedTextareas} from './Components/LineNumberedTextarea';
import {initializeSampleOrderStorage} from './Components/SampleOrderStorage';
import {initializeContentSizeWarning} from './Components/ContentSizeWarning';
import {initializeTruncatedTooltips} from './Components/TruncatedTooltip';
import {handleQuickSaveShortcut} from './Components/QuickSave';
import {initializeTwigAssistant} from './Components/TwigAssistant';
import {initializePinnedToolPanels, togglePin} from './Components/AdminTools';
import {filterLiveTable, filterLiveTableAvailability, sortLiveTable} from './Components/LiveTable';
import {initializeCardFilters} from './Components/Card';
import {initializeCreateTemplateWizards} from './Components/CreateTemplateWizard';
import {initializeCreateStoreWizards} from './Components/CreateStoreWizard';
import {initializeImportWizards} from './Components/Imports';
import {initializeDateFormatHints} from './Components/Imports/DateFormatHint';
import {initializeSheetNotices} from './Components/Imports/SheetNotice';
import {initializeExportWizards} from './Components/Exports';
import {
    handleColumnEditorClick,
    handleColumnEditorInput,
    initializeColumnEditors,
    prepareColumnEditorSubmission,
} from './Components/Exports/ColumnEditor';
import {initializeTemplateEditors} from './Components/Exports/TemplateEditor';
import {
    handleFilenamePartClick,
    handleFilenamePatternInput,
    initializeFilenameParts,
    syncFilenamePatternValidity,
} from './Components/Exports/FilenameParts';
import {initializeMobileHeaders} from './Components/MobileHeaders';
import {initializeWorkflows} from './Components/Automations/Workflow';
import {initializeSelectableCards} from './Components/SelectableCard';
import {initializeSelectableTables} from './Components/Table';
import {initializeStripe} from './Components/Stripe';
import {initializeTabs} from './Components/Tabs';
import {dispatchPreviewOnRestore, gatePreviewRequest, syncCaretPreview, syncPreviewErrorLine} from './Components/TemplatePreview';
import {formatCode, formatCodeOnShortcut} from './Components/FormatCode';
import {initializeTemplatePreviewScale} from './Components/TemplatePreviewScale';
import {switchViewMode} from './Components/ViewMode';
import {attachTemplateFieldOnFocus, growTemplateField, initializeTemplateFields} from './Components/Automations/TemplateFields';
import {refreshActionPreviews} from './Components/Automations/Actions/Preview/Synchronizer';
import {synchronizeFilterFields} from './Components/Automations/Filters/Preview/Synchronizer';
import {syncActiveConditions} from './Components/Automations/Filters/Selector/Selector';
import {initializeEventPickers} from './Components/Automations/EventPicker';
import {startResendCountdowns} from './Components/EmailVerification/SendingBlock';
import {removeDeletedAutomation} from './Components/Automations/Remover';
import {prepareAutomationSubmission} from './Components/Automations/Submission/Submission';
import {expandHistoryHash} from './Components/HistoryHashExpander';
import {closeGroupPagerJump, jumpToGroupPage, openGroupPagerJump} from './Components/SectionCard/Pager';
import {
    activateBulkSelectAll,
    animateStatCounts,
    captureStatCounts,
    explainMissingTask,
    initializeTaskAutoRefresh,
    initResumeCountdown,
    markBulkActionSubmitting,
    openGroupFromUrl,
    refreshExpandAllLabel,
    refreshStatStripOnTooltipLeave,
    rememberTaskGroup,
    reopenRememberedGroup,
    resetTaskPollBackoff,
    restoreGroupExpansion,
    runTaskNow,
    skipStatStripSwapWhileTooltipHovered,
    skipUnchangedTasksSwap,
    toggleAdminGroup,
    toggleAllTaskGroups,
    toggleTaskAutoRefresh,
    toggleTaskGroup,
} from './Components/Tasks';
import {applyItemChangeOnEnter, focusItemLookup, holdItemLookupSubmission, revealSection} from './Components/Order/NewOrder';
import {columnsSelector} from './Components/ColumnsSelector';
import {handleApiBrowserMethodChange, initializeApiBrowser} from './Components/ApiBrowser';
import {syncWarehouseMappingDirection} from './Components/WarehouseMapping';
import {
    handleScrollButtonClick as scrollFieldMapping,
    attachScrollWatchers as attachFieldMappingScrollWatchers,
    refreshFrameLayout as refreshFieldMappingLayout,
} from './Components/Imports/FieldMappingScroll';
import {
    handlePreviewMouseOver as handleImportRowMouseOver,
    handlePreviewMouseOut as handleImportRowMouseOut,
} from './Components/Imports/PreviewRow';
import {removeEmptyRunStatusFilter} from './Components/RunDetailFilter';
import {initializeFieldSlots} from './Components/Imports/FieldMapping';
import {
    preventStrayFileDrop,
    highlightDropzoneOnDragEnter,
    clearDropzoneOnDragLeave,
    acceptDroppedFile,
    cancelOversizedUpload,
    refuseOversizedFile,
    submitOnFileSelect,
    showSelectedFileName,
    prepareUpload,
    updateUploadProgress,
    updateTemplateUploadProgress,
} from './Components/Dropzone';
import {updateShipmentLineCounter as updateImportShipmentLineCounter} from './Components/Imports/AddShipments';
import {
    handleTransformationsChange,
    handleTransformationsClick,
    initializeTransformationEditors,
} from './Components/Transformations';

tippy.setDefaultProps({theme: 'light-border', zIndex: 10001});

const initializeTooltips = root => {
    tippy([...root.querySelectorAll('[data-tippy-content]')].filter(element => !element._tippy));
};

const state = {
    mousePosition: {x: 0, y: 0},
};

const trackMousePosition = event => {
    state.mousePosition.x = event.detail.requestConfig.triggeringEvent?.clientX ?? state.mousePosition.x;
    state.mousePosition.y = event.detail.requestConfig.triggeringEvent?.clientY ?? state.mousePosition.y;
};

const initializeContent = root => {
    initializePasswordRequirements(root);
    initializeCaptcha(root);
    renderRelativeTimesIn(root);

    root.querySelectorAll('.date-field-container').forEach(initializeDatepicker);
    initializeScheduleFields(root);
    initializeImagePreview(root);
    initializeCellPreviews(root);
    initializePlanEstimator(root);
    initializeLineNumberedTextareas(root);
    initializeSampleOrderStorage(root);
    initializeTemplatePreviewScale(root);
    initializeContentSizeWarning(root);
    initializeDirtyForms(root);
    initializeShakeWhenDirty(root);
    initializeScrollToError(root);
    initializeCheckboxGroups(root);
    initializeMfaInputs(root);
    initializeTruncatedTooltips(root);
    initializeTwigAssistant(root);
    initializeTemplateFields(root);
    initializeApiBrowser(root);
    attachFieldMappingScrollWatchers(root);
    initializeFieldSlots(root);
    initializeTransformationEditors(root);
    initializeCardFilters(root);
    initializePinnedToolPanels(root);
    initializeCreateTemplateWizards(root);
    initializeCreateStoreWizards(root);
    initializeImportWizards(root);
    initializeDateFormatHints(root);
    initializeSheetNotices(root);
    initializeExportWizards(root);
    initializeColumnEditors(root);
    initializeTemplateEditors(root);
    initializeFilenameParts(root);
    initializeSelectableCards(root);
    syncConnectionTestButtons(root);
    initializeSelectableTables(root);
    initializeStripe(root);
    initializeTabs(root);
    initializeMobileHeaders(root);
    initializeWorkflows(root);
    initializeToastMessages(root);
    initializeTaskAutoRefresh();

    initializeTooltips(document);

    root.querySelectorAll('[data-columns-selector]').forEach(columnsSelector.initialize);

    if (root.matches?.('[data-columns-selector]')) {
        columnsSelector.initialize(root);
    }

    if (root.matches?.('[data-task-group]')) {
        refreshExpandAllLabel();
    }

    if (root.id === 'tasks-tab-content') {
        restoreGroupExpansion(root);
    }

    syncActiveConditions(root);
    syncPreviewErrorLine(root);
    syncFilenamePatternValidity(root);
    syncPreviewNav();
};

document.addEventListener('htmx:configRequest', event => {
    prepareAutomationSubmission(event);
    appendContextIdsToRequest(event);
    prepareFieldsetSubmission(event);
    prepareColumnEditorSubmission(event);
    removeEmptyRunStatusFilter(event);
});

document.addEventListener('htmx:beforeRequest', event => {
    cancelOversizedUpload(event);
    gatePreviewRequest(event);
    rememberBundleItemFlight(event);
    trackMousePosition(event);
    columnsSelector.handleHtmxBeforeRequest(event);
    prepareButtonSpinner(event);
});

document.addEventListener('htmx:validation:halted', handleSubmissionValidationHalted);

document.addEventListener('htmx:beforeSend', prepareUpload);
document.addEventListener('htmx:xhr:progress', updateUploadProgress);
document.addEventListener('htmx:xhr:progress', updateTemplateUploadProgress);

document.addEventListener('htmx:confirm', event => {
    dropRepeatedRequest(event);

    if (!event.defaultPrevented) {
        confirmFormSubmission(event);
    }
});

document.addEventListener('htmx:beforeSwap', event => {
    if (event.detail.boosted) {
        resetSidebar();
    }

    showBoostedErrorPage(event);
    skipStatStripSwapWhileTooltipHovered(event);
    skipUnchangedTasksSwap(event);
    captureStatCounts(event);
});

document.addEventListener('htmx:beforeCleanupElement', event => {
    const element = event.detail.elt;

    clearRelativeTimeIntervals(element);

    element._tippy?.destroy();

    element.querySelectorAll?.('[data-tippy-content]').forEach(tooltipped => tooltipped._tippy?.destroy());
});

document.addEventListener('htmx:afterSwap', event => {
    syncBodyClass();
    flyBundleItem(event);
    renderRelativeTimesIn(event.target);
    renderRelativeTimesIn(event.detail.elt);
    initializeTooltips(event.target);
    animateStatCounts();
    syncFoldersCollapseHandle(event);
    focusNewRow(event);
    focusFilterInput(event.target);
    initializeEventPickers();
    startResendCountdowns(event.target);
    syncLabelBuyButton(event.target);
});

document.addEventListener('htmx:oobAfterSwap', syncFoldersCollapseHandle);
document.addEventListener('htmx:oobAfterSwap', () => syncConnectionTestButtons(document));
document.addEventListener('htmx:beforeHistorySave', removeTransientOverlays);
document.addEventListener('htmx:historyRestore', resetSidebar);

document.addEventListener('htmx:afterRequest', event => {
    removeDeletedAutomation(event);
    closeRequestingDropdown(event);
    hideConfirmedModal(event);
});

document.addEventListener('htmx:afterSettle', event => {
    initializeContent(event.target);
    refreshContextElements(event.target);

    if (event.detail.boosted) {
        initializePage();
    }
});

document.addEventListener('htmx:responseError', event => {
    if (explainMissingTask(event)) {
        return;
    }

    showResponseErrorToast(event);
});

document.addEventListener('htmx:sendError', showRequestErrorToast);
document.addEventListener('htmx:timeout', showRequestErrorToast);

document.addEventListener('selectionchange', syncCaretPreview);

document.addEventListener('paste', distributePastedMfaCode);
document.addEventListener('input', distributeFilledMfaCode);
document.addEventListener('input', filterLiveTable);
document.addEventListener('click', filterLiveTableAvailability);
document.addEventListener('click', sortLiveTable);
document.addEventListener('click', focusItemLookup);
document.addEventListener('click', revealSection);
document.addEventListener('keydown', holdItemLookupSubmission);
document.addEventListener('keydown', applyItemChangeOnEnter);
document.addEventListener('keydown', clearMfaInput);
document.addEventListener('keydown', formatCodeOnShortcut);
document.addEventListener('keyup', advanceMfaInput);

const updateBannerHeight = () => {
    const bannerContainer = document.getElementById('banner-container');
    document.body.style.setProperty('--banner-height', (bannerContainer?.offsetHeight ?? 0) + 'px');
};

const initializePage = () => {
    expandHistoryHash();

    reopenRememberedGroup();

    openGroupFromUrl();

    initResumeCountdown();

    if (document.querySelector('[data-confetti-on-load]')) {
        celebrate();
    }

    updateBannerHeight();
};

const restorePage = event => {
    dispatchPreviewOnRestore();
    syncTogglesOnRestore();

    if (!event.persisted) {
        return;
    }

    releaseFrozenRequestState();
    removeTransientOverlays();
    resetSidebar();
};

window.addEventListener('resize', updateBannerHeight);

document.addEventListener('DOMContentLoaded', () => {
    syncBodyClass();
    initializeContent(document);
    initializePage();
});

window.addEventListener('pageshow', restorePage);

document.addEventListener('mouseover', handleSidebarMouseOver);
document.addEventListener('mouseout', handleSidebarMouseOut);
document.addEventListener('transitionend', handleSidebarTransitionEnd);

document.addEventListener('submit', event => {
    if (event.target.matches('.group-form')) {
        markBulkActionSubmitting(event.target, event.submitter);
    }
});

document.addEventListener('notification:read', handleNotificationRead);
document.addEventListener('notification:allRead', handleAllNotificationsRead);

document.addEventListener('formmodal:open', event => {
    const modal = document.querySelector('.form-modal');

    if (modal) {
        openFormModal(modal);
    }
});

document.addEventListener('clipboard:copy', copySwappedContent);

document.addEventListener('toast:flash', event => showToast(event.detail.html));

document.addEventListener('toast:show', () => {
    const toastTemplates = document.querySelectorAll('template[data-template-type="toast"]');

    toastTemplates.forEach((messageTemplate) => {
        messageTemplate.parentNode.removeChild(messageTemplate);

        showToast(messageTemplate.outerHTML);
    });
});

document.addEventListener('templatefields:shape', event => {
    event.target.querySelectorAll('.automation-filter').forEach(synchronizeFilterFields);
    refreshActionPreviews(event.target);
});

document.addEventListener('sidepanel:open', event => {
    const sidepanel = document.querySelector('.side-panel');

    openPanel(sidepanel, {
        removeFromDomOnClose: true,
    });
});

document.addEventListener('sidepanel:close', clearPreviewHighlight);

document.addEventListener('contextdialog:position', event => {
    positionContextDialog(event.detail.id, state.mousePosition);
});

document.addEventListener('contextdialog:close', () => {
    closeContextDialog();
});

document.addEventListener('sidepanel:beforeOpen', event => {
    renderRelativeTimesIn(event.target);
    initializeTooltips(event.target);
});

document.addEventListener('click', event => {
    const {target} = event;

    if (handleSidebarClick(event)) {
        return;
    }

    const previewNav = target.closest('[data-preview-nav]');

    if (previewNav) {
        event.preventDefault();

        return navigatePreview(previewNav.dataset.previewNav);
    }

    handleSteppedIntegerStep(event);
    shakeDirtyFormsOutside(target);

    const taskRunLink = target.closest('[data-task-group] td.actions a');

    if (taskRunLink) {
        rememberTaskGroup(taskRunLink);
    }

    resetTaskPollBackoff();

    const filterRemoval = target.closest('[data-remove-filter]');

    if (filterRemoval) {
        return removeFilterRow(filterRemoval);
    }

    const datePickerSuffix = target.closest('.date-field-container .suffix');

    if (datePickerSuffix) {
        return toggleDatepickerFromSuffix(datePickerSuffix);
    }

    const paginationJumpTrigger = target.closest('.pagination-jump button');

    if (paginationJumpTrigger) {
        return openJumpInput(paginationJumpTrigger);
    }

    const groupPagerJumpTrigger = target.closest('.group-pager-jump button');

    if (groupPagerJumpTrigger) {
        return openGroupPagerJump(groupPagerJumpTrigger);
    }

    const adminGroupToggle = target.closest('[data-admin-group-toggle]');

    if (adminGroupToggle && !target.closest('a')) {
        toggleAdminGroup(adminGroupToggle);
    }

    const pinToolButton = target.closest('[data-pin-tool]');

    if (pinToolButton) {
        return togglePin(pinToolButton);
    }

    const confirmElement = target.closest('[data-confirm-title][hx-post]');

    if (confirmElement) {
        event.preventDefault();
        event.stopPropagation();

        return confirmHtmxAction(confirmElement);
    }

    const trustButton = target.closest('[data-trust-tested-identity]');

    if (trustButton) {
        trustTestedIdentity(trustButton);
    }

    const inlineConfirmButton = target.closest('[data-inline-confirm]');

    if (inlineConfirmButton) {
        event.preventDefault();
        event.stopPropagation();

        return handleInlineConfirm(inlineConfirmButton);
    }

    const addLineButton = target.closest('[data-add-address-line]');

    if (addLineButton) {
        event.preventDefault();

        return addAddressLine(addLineButton);
    }

    const revealOptionalFieldButton = target.closest('[data-reveal-optional-field]');

    if (revealOptionalFieldButton) {
        event.preventDefault();

        return revealOptionalField(revealOptionalFieldButton);
    }

    const addFieldsetRowButton = target.closest('[data-add-fieldset-row]');

    if (addFieldsetRowButton) {
        event.preventDefault();

        return addFieldsetRow(addFieldsetRowButton);
    }

    const removeFieldsetRowButton = target.closest('[data-remove-fieldset-row]');

    if (removeFieldsetRowButton) {
        event.preventDefault();

        return removeFieldsetRow(removeFieldsetRowButton);
    }

    const sendEmailBackButton = target.closest('[data-send-email-back]');

    if (sendEmailBackButton) {
        event.preventDefault();

        return returnToTemplateSelector(sendEmailBackButton);
    }

    const checkAllTrigger = target.closest('[data-check-all]');

    if (checkAllTrigger) {
        event.preventDefault();
        return toggleAllInScope(checkAllTrigger);
    }

    const collapseHandle = target.closest('[data-collapse]');

    if (collapseHandle) {
        event.preventDefault();
        return collapse(collapseHandle, collapseHandle.dataset.collapse);
    }

    const formatCodeButton = target.closest('[data-format-code]');

    if (formatCodeButton) {
        event.preventDefault();
        return formatCode(formatCodeButton);
    }

    const viewModeOption = target.closest('[data-view-mode-option]');

    if (viewModeOption) {
        return switchViewMode(viewModeOption);
    }

    const tabTrigger = target.closest('[data-tab-trigger]');

    if (tabTrigger) {
        event.preventDefault();
        return switchTab(tabTrigger);
    }

    const taskGroupToggle = target.closest('[data-task-group-toggle]');

    if (taskGroupToggle && !target.closest('a, button, input')) {
        return toggleTaskGroup(taskGroupToggle);
    }

    const taskGroupsExpand = target.closest('[data-task-groups-expand]');

    if (taskGroupsExpand) {
        return toggleAllTaskGroups(taskGroupsExpand);
    }

    const bulkSelectAll = target.closest('[data-bulk-select-all]');

    if (bulkSelectAll) {
        return activateBulkSelectAll(bulkSelectAll);
    }

    const expandableRowsHandle = target.closest('[data-expandable-rows]');

    if (expandableRowsHandle) {
        const interactiveElement = target.closest('button, a, input, select, time');
        const clickedInteractiveChild = interactiveElement !== null
            && interactiveElement !== expandableRowsHandle
            && expandableRowsHandle.contains(interactiveElement);

        if (!clickedInteractiveChild) {
            event.preventDefault();
            return toggleRows(expandableRowsHandle);
        }
    }

    const clampToggle = target.closest('[data-toggle-clamp]');

    if (clampToggle) {
        event.preventDefault();
        clampToggle.closest('.clampable')?.classList.toggle('is-expanded');
        return;
    }

    const fieldMappingScrollButton = target.closest('.field-mapping-scroll-button');

    if (fieldMappingScrollButton) {
        event.preventDefault();
        return scrollFieldMapping(fieldMappingScrollButton);
    }

    if (handleColumnEditorClick(event)) {
        return;
    }

    if (handleFilenamePartClick(event)) {
        return;
    }

    if (handleTransformationsClick(event)) {
        return;
    }

    if (target.tagName === 'TIME') {
        return timeElementClickedHandler(target);
    }

    const taskRunButton = target.closest('[data-task-run]');

    if (taskRunButton) {
        return runTaskNow(taskRunButton);
    }

    if (
        target.tagName === 'INPUT'
        && target.matches('[type=checkbox]')
        && target.dataset.checkboxGroup !== undefined
    ) {
        if (isLockedPermission(target)) {
            event.preventDefault();

            return;
        }

        handleCheckboxGroupClick(target, event);
        updateContextElements(target.dataset.checkboxGroup);
        return document.dispatchEvent(new GroupedCheckboxChanged(target, target.dataset.checkboxGroup));
    }

    const closeSidePanelTrigger = target.closest('[data-close-sidepanel]');

    if (closeSidePanelTrigger) {
        return document
            .querySelector('.side-panel')
            ?.dispatchEvent(new CustomEvent('closesidepanel', {bubbles: true}))
        ;
    }

    const closeModalTrigger = target.closest('[data-close-modal]');

    if (closeModalTrigger) {
        return document
            .querySelector('.form-modal')
            ?.dispatchEvent(new CustomEvent('closemodal', {bubbles: true}))
        ;
    }

    const closeContextDialogTrigger = target.closest('[data-close-context-dialog]');

    if (closeContextDialogTrigger) {
        closeContextDialog();
        return;
    }

    const closeBannerTrigger = target.closest('[data-close-banner]');

    if (closeBannerTrigger) {
        closeBannerTrigger.closest('.banner').remove();
        updateBannerHeight();

        if (!document.querySelector('.banner')) {
            window.removeEventListener('resize', updateBannerHeight);
        }
    }

    const selectContainer = target.closest('.select-container');

    if (selectContainer !== null) {
        if (dropdownState.hasActiveDropdown) {
            document.dispatchEvent(new CloseDropdownMenus());
        }

        return clickSelectContainer(target, selectContainer);
    } else if (selectState.hasActiveDropdown) {
        document.dispatchEvent(new CloseDropdowns());
    }

    const copyToClipboard = target.closest('[data-copy-to-clipboard]');

    if (copyToClipboard) {
        event.preventDefault();

        return copyText(copyToClipboard.dataset.copyToClipboard, copyToClipboard.dataset.copyToClipboardLabel);
    }

    if (target.closest('[data-confetti]')) {
        return celebrate();
    }

    if (target.closest('[data-enable-screenshot-mode]')) {
        return enableScreenshotMode();
    }

    const notificationBellContainer = target.closest('.notification-bell-container');

    if (notificationBellContainer !== null) {
        handleNotificationBellClick(notificationBellContainer, target);

        return;
    }

    const dropdownContainer = target.closest('.dropdown-container');

    if (dropdownContainer !== null) {
        if (dropdownContainer.dataset.checkAllOnOpen && target.closest('.dropdown-trigger')) {
            checkAllOnDropdownOpen(dropdownContainer);
        }

        clickDropdownContainer(target, dropdownContainer);

        return;
    } else if (dropdownState.hasActiveDropdown) {
        document.dispatchEvent(new CloseDropdownMenus());
    }

    const inputArea = target.closest('.editable-tags .input-area');

    if (inputArea !== null) {
        if (target.matches('.fa-xmark')) {
            event.stopImmediatePropagation();
            return document.dispatchEvent(
                new RemoveEditableTag(inputArea.closest('.editable-tags'), target.closest('.tag')),
            );
        }

        return document.dispatchEvent(new FocusInput(inputArea.closest('.editable-tags')));
    }

    const addInventoryButton = target.closest('[data-add-inventory]');

    if (addInventoryButton) {
        return addInventoryRow(addInventoryButton);
    }

    const removeInventoryButton = target.closest('[data-remove-inventory]');

    if (removeInventoryButton) {
        return removeInventoryRow(removeInventoryButton);
    }

    const removeRowButton = target.closest('[data-remove-row]');

    if (removeRowButton) {
        return removeRow(removeRowButton);
    }

    const clearFieldButton = target.closest('[data-clear-field]');

    if (clearFieldButton) {
        return clearField(clearFieldButton);
    }

    const removeAllTagsButton = target.closest('[data-remove-all-tags]');

    if (removeAllTagsButton) {
        return removeAllTags(removeAllTagsButton);
    }

    const columnsSelectorCommit = target.closest('[data-columns-selector-expander-commit]');

    if (columnsSelectorCommit) {
        event.preventDefault();
        return columnsSelector.handleExpanderCommit(columnsSelectorCommit);
    }

    const columnsSelectorExpanderButton = target.closest('[data-columns-selector-expander]');

    if (columnsSelectorExpanderButton) {
        event.preventDefault();
        return columnsSelector.handleExpanderClick(columnsSelectorExpanderButton);
    }

    if (triggerRowPreview(target)) {
        return;
    }
});

document.addEventListener('pointerdown', event => {
    columnsSelector.handleOutsidePointerDown(event.target);
});

document.addEventListener('mouseover', handleImportRowMouseOver);
document.addEventListener('mouseout', event => {
    handleImportRowMouseOut(event);
    refreshStatStripOnTooltipLeave(event);
});

document.addEventListener('submit', handleCreatePdfSubmit);

document.addEventListener('dragover', preventStrayFileDrop);
document.addEventListener('dragenter', highlightDropzoneOnDragEnter);
document.addEventListener('dragleave', clearDropzoneOnDragLeave);
document.addEventListener('drop', acceptDroppedFile);

window.addEventListener('resize', refreshFieldMappingLayout);

document.addEventListener('input', handleSuggestionsInput, true);
document.addEventListener('mousedown', handleSuggestionsMousedown);
document.addEventListener('suggestions:selected', handleProductPrefill);

document.addEventListener('focusin', event => {
    openSelectOnFocus(event);

    attachTemplateFieldOnFocus(event.target);

    handleSuggestionsFocus(event);

    const tagsContainer = event.target.closest('.editable-tags');

    if (tagsContainer !== null) {
        if (!tagsContainer.querySelector('.input-area').classList.contains('focus')) {
            return document.dispatchEvent(new FocusInput(tagsContainer));
        }
    }
});

document.addEventListener('keydown', event => {
    if (handleSuggestionsKeydown(event)) {
        return;
    }

    handleQuickSaveShortcut(event);

    if (event.key === 'Shift') {
        document.onselectstart = () => false;
    }

    if (event.key === 'Escape' && event.target.matches?.('.pagination-jump input')) {
        return closeJumpInput(event.target);
    }

    if (event.target.matches?.('.group-pager-jump input')) {
        if (event.key === 'Escape') {
            return closeGroupPagerJump(event.target);
        }

        if (event.key === 'Enter') {
            event.preventDefault();

            return jumpToGroupPage(event.target);
        }
    }

    const editableTags = event.target.closest('.editable-tags');

    if (event.key === 'Enter') {
        if (event.target.matches('input[data-sample-order-storage]')) {
            event.preventDefault();
            event.target.blur();
        }

        if (editableTags) {
            event.preventDefault();
            document.dispatchEvent(new TagInputContent(editableTags));
        }

        if (event.target.matches('[data-columns-selector-expander-input]')) {
            columnsSelector.submitExpanderInput(event.target, event);
        }
    } else if (event.key === 'Backspace') {
        if (editableTags) {
            if (editableTags.querySelector('input[type=text]').value === '') {
                document.dispatchEvent(new RemoveLastTag(editableTags));
            }
        }
    }
});

document.addEventListener('keyup', event => {
    if (event.key === 'Shift') {
        document.onselectstart = null;
    }
})

document.addEventListener('focusout', event => {
    if (event.target.matches?.('.pagination-jump input')) {
        closeJumpInput(event.target);
    }

    if (event.target.matches?.('.group-pager-jump input')) {
        closeGroupPagerJump(event.target);
    }
});

document.addEventListener('submit', event => {
    if (event.target.matches?.('[data-columns-selector]')) {
        columnsSelector.handleSubmit(event.target, event);
    }

    // the filter controls auto-search; stop Enter from firing a native full-page GET
    if (event.target.matches?.('form.search-filters')) {
        event.preventDefault();
    }

    if (event.target.matches?.('form.pagination-jump')) {
        event.preventDefault();
        submitJump(event.target);
    }
}, true);

document.addEventListener('change', event => {
    const {target} = event;

    handleProductPrefill(event);

    if (target.matches('[data-tasks-auto-refresh]')) {
        toggleTaskAutoRefresh(target);
    }

    if (target.matches('.filter-card > .header input[type=checkbox]')) {
        handleFilterCardToggle(target);
    }

    if (target.matches('.filter-card .mode-row input[type=radio]')) {
        handleFilterCardModeChange(target);
    }

    if (target.matches('[data-folder-scope-mode]')) {
        handleFolderScopeModeChange(target);
    }

    if (target.matches('.permissions')) {
        syncPermissionDependencies(target);
    }

    if (target.matches('[data-interval-toggle-switch]')) {
        handleIntervalToggleChange(target);
    }

    if (target.matches('[data-setting-toggle-switch]')) {
        handleSettingToggleChange(target);
    }

    if (target.matches('[data-columns-selector] input[type=checkbox]')) {
        columnsSelector.handleCheckboxChange(target);
    }

    if (target.matches('.warehouse-mappings select')) {
        syncWarehouseMappingDirection(target);
    }

    if (target.matches('[data-default-ports] select')) {
        applyDefaultPort(target);
    }

    handleConnectionTestInput(target);

    if (target.matches('.pagination-per-page select')) {
        changePerPage(target);
    }

    refreshTagPreview(target);

    popTagColorSwatch(target);

    refuseOversizedFile(target);

    submitOnFileSelect(target);

    showSelectedFileName(target);

    handleBulkActionChange(target);

    handleLabelPurchaseChange(target);

    handleTransformationsChange(event);

    markAssociatedFormDirty(target);
});

document.addEventListener('input', event => {
    clearSubmissionValidationState(event);

    updateImportShipmentLineCounter(event);

    handleColumnEditorInput(event);
    handleFilenamePatternInput(event);

    if (event.target.matches?.('textarea[data-templatable]')) {
        growTemplateField(event.target);
    }

    if (event.target.matches('[data-columns-selector-search]')) {
        columnsSelector.handleSearchInput(event.target);
    }

    refreshTagPreview(event.target);

    handleApiBrowserMethodChange(event.target);

    handleConnectionTestInput(event.target);

    markAssociatedFormDirty(event.target);
});

document.addEventListener('input', handlePasswordLength);
document.addEventListener('change', handlePasswordLength);
document.addEventListener('submit', handlePasswordRequirementsSubmit, true);
document.addEventListener('change', handleRequiredCheckboxChange);
document.addEventListener('submit', handleRequiredCheckboxSubmit, true);
document.addEventListener('submit', handleCaptchaSubmit);
document.addEventListener('htmx:historyRestore', () => initializeContent(document.querySelector('[hx-history-elt]') ?? document.body));
